import React from 'react';

function Blog() {
  return (
    <header className="App-header">
      <div className="container">
      <h1 className='App-header'>
        <a className="apple-link" href="https://jessy-travel-journey.netlify.app/" target="_blank" rel="noopener noreferrer">
          Visit Our Travel Blog
        </a>
      </h1>
      </div>
    </header>
  );
}

export default Blog;